<template>
    <div class="checked-goods">
        <h3 v-if="result.messages" class="def-header-3">{{result.messages.title}}</h3>

        <DefSliderWrapper v-if="screenWidth >= 992">
            <swiper
                :modules="modules"
                :slides-per-view="6"
                :space-between="4"
                :pagination="{ clickable: true }"
                navigation
            >
                <swiper-slide
                    v-for="item in result.items"
                    :key="item.id"
                >
                    <a :href="item.detailPage">
                        <img
                            :key="item.id"
                            :src="item.picture.src"
                            :alt="item.picture.alt"
                            class="checked-goods__image"
                        >
                    </a>
                </swiper-slide>
            </swiper>
        </DefSliderWrapper>

        <PerfectScrollbar v-else class="checked-goods__mobile">
<!--            <product-card-2 v-for="(item,i) in result.items" :key="i" :result="item"/>-->
            <a v-for="item in result.items" :key="item.id" :href="item.detailPage">
                <img :key="item.id" :src="item.picture.src" :alt="item.picture.alt">
            </a>
        </PerfectScrollbar>
    </div>
</template>

<script>
import {Navigation, Pagination} from "swiper";
import { Swiper, SwiperSlide } from 'swiper/vue';
export default {
    name: 'CheckedGoods',
    props: {
        result: {
            type: Object,
            default: () => ({
                "messages": {"title": "Бестселлеры"},
                "items": [
                    {
                        "id": "52612",
                        "name": "Браслет из белого золота с бриллиантами. Артикул: 421650120201",
                        "detailPage": "/catalog/test/braslet-iz-belogo-zolota-s-brilliantami-artikul-421650120201/",
                        "article": "52612",
                        "price": {"price": 0, "printPrice": "0 грн."},
                        "offer": {"id": "57663", "price": {"price": 0, "printPrice": "0 грн."}, "current": true},
                        "offers": [{
                            "id": "57663",
                            "price": {"price": 0, "printPrice": "0 грн."},
                            "current": true
                        }, {"id": "57066", "price": {"price": 0, "printPrice": "0 грн."}, "current": false}, {
                            "id": "57065",
                            "price": {"price": 0, "printPrice": "0 грн."},
                            "current": false
                        }, {"id": "57064", "price": {"price": 0, "printPrice": "0 грн."}, "current": false}, {
                            "id": "57063",
                            "price": {"price": 71918, "printPrice": "71918 грн."},
                            "current": false
                        }],
                        "propsForCheck": {
                            "SIZES": {
                                "165": {
                                    "name": "165",
                                    "displayValue": "165",
                                    "value": "165",
                                    "disable": null,
                                    "active": null,
                                    "type": "img"
                                },
                                "170": {
                                    "name": "170",
                                    "displayValue": "170",
                                    "value": "170",
                                    "disable": null,
                                    "active": null,
                                    "type": "img"
                                },
                                "175": {
                                    "name": "175",
                                    "displayValue": "175",
                                    "value": "175",
                                    "disable": null,
                                    "active": null,
                                    "type": "img"
                                },
                                "180": {
                                    "name": "180",
                                    "displayValue": "180",
                                    "value": "180",
                                    "disable": null,
                                    "active": true,
                                    "type": "img"
                                },
                                "190": {
                                    "name": "190",
                                    "displayValue": "190",
                                    "value": "190",
                                    "disable": null,
                                    "active": null,
                                    "type": "img"
                                }
                            }
                        },
                        "picture": {
                            "alt": "Браслет из белого золота с бриллиантами. Артикул: 421650120201",
                            "src": "/upload/resize_cache/iblock/815/200_200_140cd750bba9870f18aada2478b24840a/815c98274d95fd3c2ddaa9446baad3b8.jpg"
                        }
                    }
                ],
            })
        }
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            modules: [Navigation, Pagination],
        }
    },
}
</script>

<style lang="scss">
.checked-goods{
    margin: 24px 0;
    width: 100%;
    margin-top: 0;
    @include point-md{
        margin: 30px 0;
        margin-top: 0;
    }
    @include point-lg{
        margin: 48px 0;
    }
    &__image{
        display: block;
        max-width: 100%;
    }
    &__mobile{
            display: flex;
            overflow-x: auto;
            margin: 28px 0;
            padding-bottom: 20px;
            & > * {
                //width: 100%;
                &:not(:last-child) {
                    margin-right: 4px;
                }
            }
            img{
                width: 176px;
                @include point-md{
                    width: 176px;
                }
            }
    }
}
</style>
